// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__px_af","col":"styles_col__3AMEo","fulfillmentStatus":"styles_fulfillmentStatus__SiZY7","emailCol":"styles_emailCol__1cI9K"};